import React from 'react';
import { Product, Team } from 'teams';
import noop from 'utils/noop';

export interface ComponentContext {
  /**
   * list of all parent components, separated by .
   */
  componentBreadCrumbs: string;
  /**
   * last parent component, used in the use-rum-action hook to name the action
   */
  component: string;
  /**
   * Team that owns this component
   */
  teamName: Team;
  /**
   * Product under which this component falls under.
   */
  productName: Product;
  /**
   * custom attributes passed to all actions under this context
   */
  customAttributes?: object;
  setTeamName: (team: Team) => void;
  setProductName: (product: Product) => void;
}

export const RumComponentContext = React.createContext<ComponentContext>({
  teamName: '' as Team,
  productName: '' as Product,
  componentBreadCrumbs: 'root',
  component: 'root',
  setTeamName: noop,
  setProductName: noop,
});
